<svelte:head>

<script type="text/javascript" src="https://code.jquery.com/jquery-1.11.2.min.js"              on:load={jqueryLoaded}    integrity="sha256-Ls0pXSlb7AYs7evhd+VLnWsZ/AqEHcXBeMZUycz/CcA=" crossorigin="anonymous" defer></script>
<script type="text/javascript" src="https://code.jquery.com/ui/1.11.4/jquery-ui.min.js"        on:load={jqueryuiLoaded}  integrity="sha256-xNjb53/rY+WmG+4L6tTl9m6PpqknWZvRt0rO1SRnJzw=" crossorigin="anonymous" defer></script>

</svelte:head>

<script>

import { onMount, onDestroy } from 'svelte';


// ----------------------------------------------------
// --   DECLARATIONS
// ----------------------------------------------------

	onMount(async () => {
		// fetch data
		handleClickGetResult();
	});


   let query_pid = "";
	let seconds = 0;
   
	const interval = 0;

   let display_pivot = false;


  var is_dependenciesLoaded = false;
  function dependenciesLoaded() {
  		if (   true 
  		       && is_jqueryLoaded 
  		       && is_jqueryuiLoaded 
  		       && is_dataLoaded 
  		   )
  	  {
			is_dependenciesLoaded = true;
  		}
  }


  var is_jqueryLoaded = false;
  function jqueryLoaded() {
		// The external javascript library is ready.
		is_jqueryLoaded = true;
		dependenciesLoaded();
  }

  var is_jqueryuiLoaded = false;
  function jqueryuiLoaded() {
		// The external javascript library is ready.
		is_jqueryuiLoaded = true;
		dependenciesLoaded();
  }

   let query_environment = 'dev';
   let query_id = 'NyCZQfEFQaF2vwpk';

  let display_loadtimer = false;

  async function handleClickGetConfig () {
          var config = jQuery("#pivot").data("pivotUIOptions");
          var config_copy = JSON.parse(JSON.stringify(config));
          //delete some values which will not serialize to JSON
          delete config_copy["aggregators"];
          delete config_copy["renderers"];
          console.log(config_copy);
      }

  let query_data = {};
  var is_dataLoaded = false;
  async function handleClickGetResult () {
			// Call an authentication microservice to handle the authentication.
//			var response = await fetch("https://analytics.artificiality.be/opendata/"+query_id+".json",  // CORS ISSUE
			var response = await fetch("https://www.artificiality.be/dev/opendata/"+query_id+"/result",
			{
			    method: 'GET',
			    credentials: 'include',    // omit | include | same-origin
			    headers: {
			        'api_id': 'API_KEY',
			        'client_id': 'CLIENT_ID',
			        'client_secret': 'CLIENT_SECRET',
			        'client_session': CLIENT_SESSION,
			        'Content-Type': 'application/vnd.artificiality.drill.query-v1+json',
			        'Accept':       'application/vnd.artificiality.drill.queryresult-v1+json',
			        'pragma':				'no-cache',
			        'cache-control':	'no-cache',			        
   			    },
//			    body: JSON.stringify({ }),
			})
			.then((response) => response.json())
			.then((response) => {
//console.log(response);
response = JSON.parse( response.response.data );

						query_data = [];
						var query_data_columns = [];

						if (response.queryState === "COMPLETED" && response.query.length > 0) {

//								query_data.push(response.columns);
								query_data_columns = Object.keys(response.query[0]);
								query_data.push( query_data_columns );
								
								for (var i = 0; i < response.query.length; i++) {
									 // convert dict to array
									 var row = [];
									 for (var j = 0; j < query_data_columns.length; j++) {
									 	row.push(  response.query[i][ query_data_columns[j] ]  );
									 }
									// push row to dataset 
									query_data.push(  row ); 
								}
								
								is_dataLoaded = true;
								dependenciesLoaded();
						}

			  })
			  .catch((err) => {
console.log(err);
			})
			;
  }

// ----------------------------------------------------
// --   RUNTIME 
// ----------------------------------------------------


//$: run = is_dependenciesLoaded && handleClickGetResult()  // <<-- should be hanlded in the onMount() ??

$: display_pivot = is_dependenciesLoaded;


</script>


<style>

	.applet {
		width: inherit;
		height: inherit;
	}
	
	.jsfiddle {
		width: inherit;
		height: 550px;
	}
	

</style>


<div class="applet">


	{#if is_dependenciesLoaded}

		{#if  display_pivot}
		<iframe class="jsfiddle" title="artififiddle/5fk1do6g"
         src="//jsfiddle.net/artififiddle/5fk1do6g/1/embedded/result/?embed_param_API_KEY=API_KEY&embed_param_CLIENT_ID=CLIENT_ID&embed_param_CLIENT_SECRET=CLIENT_SECRET&embed_param_CLIENT_SESSION=12345678" 
         allowfullscreen="allowfullscreen" 
         frameborder="0"></iframe>
	
		{:else if display_loadtimer}
		<div>
			<p>It's been running for {seconds} seconds</p>
			<p>query_pid: {query_pid} </p>
		</div>
	
		{:else}
		<div>
			<p> Scripts loaded </p>		
			<p> Loading data and what not... </p>			
		</div>

		{/if}

	{:else}
	<div>
		<p> Loading scripts and what not... </p>			
	</div>

	{/if}


</div>